import React, { useEffect, useState } from "react";
import { Formik, Form, Field, ErrorMessage, useFormikContext } from "formik";
import InputLayout from "../../../../atoms/InputLayout";
import * as Yup from "yup";
import CountryCodeDropdown from "../../../../molecules/Dropdown/CountryCodeDropdown";
import Error from "../../../../atoms/Error";
import { patchData, postData } from "../../../../../services";
import { useCookies } from "react-cookie";
import toast from "react-hot-toast";
import {
  confimationStyles,
  errorStyles,
} from "../../../../../assets/styles/toast";

const BusinessSegmentForm = ({ onFormDirty, onClose , initialData , refetchData }) => {

  const [cookies] = useCookies(["e_t"]);
  const [isSubmitting, setIsSubmitting] = useState(false);
  // Initial form values
  const initialValues = {
    name: initialData?.name || null,
    // email: initialData?.email || null,
    desc: initialData?.description || null,
  };

  // Validation schema using Yup
  const validationSchema = Yup.object().shape({
    name: Yup.string().required("Name is required"),
    // email: Yup.string()
    // .matches(
    //   /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
    //   "Invalid email format"
    // )
    // .required("Email is required"),

  });



  const handleSubmit = async ({ values, resetForm }) => {
    try {
      const res = await postData({
        //BusinessSegment
        endpoint: "BusinessSegment/addBusinessSegmentById",
        data: {name : values.name,description:values.desc,},
        token: cookies.e_t,
      });

      if (res) {
        toast.success("Business Segment Added Successfully", {
          style: confimationStyles,
          duration: 1000,
        });
        refetchData();
        setIsSubmitting(false);
        onClose();
        resetForm();
      }
    } catch (err) {
      setIsSubmitting(false);
    }
  };

  const handleEdit = async (values) => {
    try {
      const res = await patchData({
        //BusinessSegment/update
        endpoint: "BusinessSegment/updateBusinessSegmentById",
        token: cookies.e_t,
        data: {
          name : values.name,
          description: values.desc,
          id : initialData?.id,
        },
      });

      if (res.status) {
        toast.success("Business Segment Updated Successfully", {
          style: confimationStyles,
          duration: 1000,
        });
        refetchData();
      } else {
        toast.error(res.message, { style: confimationStyles, duration: 1000 });
      }

      onClose();
    } catch (error) {}
  };


  return (
    <Formik
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={(values, { resetForm }) => {
        initialData ? handleEdit(values) : handleSubmit({ values, resetForm });
        onFormDirty(false); 
      }}
      validateOnBlur={false}
      validateOnChange={false}
    >
      {({ values, setFieldValue, touched, errors , dirty }) => (
        <>
          <FormObserver onFormDirty={onFormDirty} />
          <Form>
            <div className="row gx-4">
              <InputLayout>
                <label className="required-field">Name</label>
                <Field name="name" />
                <Error error={errors.name} />
              </InputLayout>
              {/* <InputLayout>
                <label>Email</label>
                <Field name="email" type="email" />
                <Error error={errors.email} />
              </InputLayout> */}
            </div>

            <div className="row mt-3">
              <InputLayout>
              <label>Description</label>
              <Field name = "desc" as='textarea'/>
              <Error error = {errors.desc}/>
              </InputLayout>
            </div>

           
            <div className="modal-footer mt-4">
              <button
                type="button"
                className="btn btn-transparent"
                onClick={() => onClose()}
              >
                Cancel
              </button>
              <button
                type="submit"
                className="btn btn-primary"
                disabled={isSubmitting || !dirty}
              >
               {initialData ? "Update": "Save"}
              </button>
            </div>
            {/* Submit Button */}
          </Form>
        </>
      )}
    </Formik>
  );
};

// Custom component to track form dirty state
const FormObserver = ({ onFormDirty }) => {
  const { dirty } = useFormikContext();

  useEffect(() => {
    onFormDirty(dirty); // Notify parent about form state
  }, [dirty, onFormDirty]);

  return null;
};

export default BusinessSegmentForm;
